import { Link } from '@tanstack/react-router'
import { Icon } from '@/components/atoms'
import { PayablesSummarySearchParams } from '@/types'

interface NavigateToPreviousLinkProps {
    to: string
    label: string
    search?: PayablesSummarySearchParams
}

export const NavigateToPreviousLink: React.FC<NavigateToPreviousLinkProps> = ({
    to,
    label,
    search,
}) => {
    return (
        <div className="px-6">
            <Link
                data-testid="back-link"
                className="inline-flex items-center gap-1 text-linkPrimary"
                to={to}
                search={search}
            >
                <Icon name="arrow_back" size="small" />
                <span className="text-label-small">{label}</span>
            </Link>
        </div>
    )
}
